<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <v-row class="pa-4">
    <v-col cols="12" xs="12" sm="12" class="pt-0 py-0">
      <span class="headline">Support</span>
    </v-col>
    <v-col cols="12" xs="12" sm="12" class="py-0">
      <v-checkbox outlined v-model="showAll" class="mx-2" label="Auch online anzeigen" @change="reFilter"></v-checkbox>
    </v-col>
    <v-col cols="12" xs="12" sm="3" md="3">
      <v-autocomplete
          v-model="filterNetwork"
          :items="companies"
          outlined
          clearable
          item-text="name"
          return-object
          dense
          @click:clear.stop="doClear"
          @change="reloadSupportList"
          label="Netzwerk"
      ></v-autocomplete>
    </v-col>
    <v-col cols="12" xs="12" sm="3" md="3" v-if="false">
      <v-autocomplete
          v-model="filterTown"
          :items="towns"
          outlined
          chips
          dense
          deletable-chips
          small-chips
          @change="reFilter"
          label="Stadt"
      ></v-autocomplete>

    </v-col>
    <v-col cols="12" xs="12" sm="3" md="2">
      <v-select
          v-model="filterStati"
          :items="stati"
          outlined
         clearable
          dense
          @change="reFilter"
          label="Status"
      ></v-select>
    </v-col>
    <v-col cols="12" xs="12" sm="3" md="2" v-if="false">
      <v-select
          v-model="filterTags"
          :items="tags"
          outlined
          chips
          dense
          deletable-chips
          small-chips
          @change="reFilter"
          label="Gruppe"
          multiple
      ></v-select>
    </v-col>
    <v-col cols="12" xs="3" sm="6" md="6" class="pt-0 py-0 text-right" align="end">
      <v-text-field
          v-model="search"
          label="Suche"
          single-line
          @click:clear="reloadSupportList"
          @change="reloadSupportList"
          clearable
          append-outer-icon="search"
          hide-details
      ></v-text-field>
    </v-col>
    <v-col cols="12" xs="12" align="end">
      <span>Anzahl: {{stats.cnt}} / (<span style="color: red" title="Anzahl offline">{{stats.cntOffline}}</span> / <span style="color:green" title="Anzahl online">{{stats.cntOnline}}</span>  )</span>
      <v-btn @click="reloadSupportList()" class="ml-4" color="primary">Aktualisieren</v-btn>
    </v-col>
    <v-col cols="12" xs="12">

      <v-data-table
          :headers="headers"
          :items="deviceList"
          show-select
          fixed-header
          :height="tableHeight"
          sort-by="indicatorSort"
          sort-desc
          v-model="selected"
          hide-details
          :options.sync="pagination"
          :items-per-page="50"
          :footer-props="{
            'items-per-page-options': [10, 20, 50, 100]
          }"
      >

        <template v-slot:item.indicatorSort="{ item }">
          <div :title="'Screen '+ item.screenNumber">
            <span class="handpointer" @click="editItem(item)" v-if="item.isService === 1"> SERVICE</span>
            <span class="handpointer" @click="editItem(item)" v-else> {{ item.deviceState }}</span>
          </div>
        </template>
        <template v-slot:item.deviceState="{ item }">
          <v-icon small :style="getIndicatorStyle(item)">lens</v-icon>
          <span class="handpointer" @click="editItem(item)"> {{ item.deviceState }}</span>
        </template>
        <template v-slot:item.name="{ item }">
          <span @click="editItem(item)" class="handpointer"> {{item.name}}</span><br>
          <span @click="editItem(item)" class="handpointer">{{item.playlistName}}</span><br>
          <span style="font-size: 10px"> {{ item.androidId }} / {{ item.remoteAddress }}</span>
        </template>
        <template v-slot:item.androidId="{ item }">
          <span> {{ item.androidId }} / {{ item.remoteAddress }}</span>
        </template>
        <template v-slot:item.clientVersionString="{ item }">
          <span class="handpointer"
                @click="editItem(item)"> {{ item.clientVersionString }} / {{ item.setClientVersion }}</span>
        </template>
        <template v-slot:item.diskUsageCurrent="{ item }">
          <span
              :style="getHDStyle(item)">{{
              toMB(item.diskUsageCurrent, 2)
            }}</span><span> von {{ toMB(item.diskUsageMax, 2) }}</span>
        </template>
        <template v-slot:item.lastHeartbeat="{ item }">
          <div>
            <v-icon small :style="getIndicatorStyle(item)">lens</v-icon>
            <span>{{ tableUtils.convertToDateTime(item.lastHeartbeat) }} </span><br>
          </div>
        </template>
        <template v-slot:item.edited="{ item }">
          <span>{{ tableUtils.convertToDateTime(item.edited) }} </span><br>
        </template>


        <template v-slot:item.tags="{ item }">
          <v-chip v-for="(c,i) in getTags(item)" :key="i">
            {{ c }}
          </v-chip>
        </template>
        <template v-slot:item.company="{ item }">
          <span v-if="item.companyName" @click="openCompany(item)">{{ item.companyName }}</span>
          <span v-if="!item.companyName" class="handpointer" :style="getCompanyStyle(item)" @click="openCompanyDialog(item)">zuweisen</span>
        </template>
        <template v-slot:item.action="{ item }">
          <v-icon
              small
              class="mr-2"
              @click="editItem(item)"
          >
            edit
          </v-icon>
          <v-icon
              v-if="false"
              small
              @click="deleteItem(item)"
          >
            delete
          </v-icon>
        </template>
      </v-data-table>
    </v-col>
    <DialogLinkCompany ref="dlgLink" @save="onLinkCompany"></DialogLinkCompany>
    <DialogDeleteItem ref="dlgDelete" @doDelete="doDelete"></DialogDeleteItem>
  </v-row>
</template>

<script>
import Vue from 'vue'
import DialogLinkCompany from './../module/dialogs/DialogLinkCompany'
import DialogDeleteItem from "../dialogs/DialogDeleteItem";

var _ = require('lodash')
export default {
  name: 'TableSupport',
  props: {
    companyId: String,
    showTitle: Boolean,
    showReload: Boolean,
    isCompanyView: Boolean
  },
  components: {DialogLinkCompany, DialogDeleteItem},
  data() {
    return {

      companies: [],
      currentDevice: null,
      search: null,
      tableHeight: 200,
      showAll: false,
      pagination: {},
      stats: {
        cnt: 0,
        cntOffline: 0,
        cntOnline: 0
      },
      selected: [],
      tags: [],
      towns: [],
      tableUtils: require('./TableUtils').default,
      filterTags: [],
      filterTown: null,
      filterStati: null,
      filterNetwork: null,
      networks: [],
      stati: ['ACTIVE', 'NEW', 'SERVICE'],
      headers: [
        {text: 'Status', value: 'indicatorSort'},
        {text: 'Name', align: 'left', value: 'name'},
        /*{text: 'Android Id', align: 'left', value: 'androidId'},*/
        {text: 'Standort', value: 'company'},
        {text: 'Stadt', align: 'left', value: 'companyTown'},
        /*{text: 'Screen', value: 'screenNumber'},*/
        /*{text: 'Client Version', value: 'clientVersionString'},*/
        /*{text: 'Tags', value: 'tags'},*/
        {text: 'HD Kapazität', value: 'diskUsageCurrent'},
        /*{text: 'Erstellt', value: 'created'},*/
        {text: 'Letzte Rückmeldung', value: 'lastHeartbeat', width: 180},
        /*{text: 'Remote', value: 'remoteAddress'},*/
        {text: 'Zuletzt bearbeitet', value: 'edited'},
        {text: 'Aktion', value: 'action'}
      ],
      deviceList: []
    }
  },
  methods: {
    deleteItem: function (item) {
      this.$refs.dlgDelete.open({
        type: 'Gerät',
        id: '' + item.guid,
        name: 'Gerät ' + item.name,
        item: item
      })
    },
    doDelete: function (item) {
      Vue.prototype.$api.deleteDevice(item.item.guid, this.reload)
    },
    openCompany: function (item) {
      const cmp = this
      Vue.prototype.$apiCompany.loadCompany(item.guidCompany, function (cdata) {
        if (cdata.guidParent) {
          cmp.$router.push('/Netzwerke/' + cdata.guidParent)
        } else {
          cmp.$router.push('/Netzwerke/' + cdata.guid)
        }
      })
    },
    openCompanyDialog: function (item) {
      console.log('openCompanyDialog', item)
      this.currentDevice = item
      this.$refs.dlgLink.open({
        title: 'Netzwerk zuweisen',
        description: 'Wählen Sie ein Netzwerk'
      })
    },
    sendEmail: function (item) {
      console.log('sendEmail', item)
      let devicePerCompany = {}
      const cmp = this
      _.forEach(this.deviceList, function (device) {
        const index = cmp.getIndicatorIndex(device)
        if (index === 2) {
          if (!devicePerCompany['' + device.guidCompany]) {
            devicePerCompany['' + device.guidCompany] = {
              name: device.companyName,
              mail: device.companyMail,
              guid: device.guidCompany,
              guidParent: device.guidParent,
              guidDevice: device.guid,
              devices: []
            }
          }
          devicePerCompany['' + device.guidCompany].devices.push(device)
        }
      })
      const mail = {
        subject: 'Geräte sind offline bitte Prüfen',
        message: 'bitte prüfen Sie folgende Geräte:\n\n[EXTRA_DATA]',
        extra: devicePerCompany
      }
      console.log('mail', mail, devicePerCompany)

      this.$refs.dlgEMail.open(mail)
    },
    onLinkCompany: function (item) {
      console.log('onLinkCompany', item)
      Vue.prototype.$api.linkDeviceToCompany(this.deviceGuid, item, this.reload)
    },
    editItem: function (item) {
      const cmp = this
      const idx = cmp.deviceList.findIndex((value) => {
        return value.guid === item.guid}
      )
      const supportState = {
        current: item,
        index: idx,
        list: cmp.deviceList
      }
      Vue.prototype.storage.saveState("SupportList", supportState)
      this.$router.push('/Netzwerke/' + item.guidCompany + '/Geraete/' + item.guid)
    },
    getIndicatorIndex: function (item) {
      const diff = new Date().getTime() - item.lastHeartbeat
      if (diff >= 60 * 24 * 60000) {
        return 2
      }
      return 0
    },
    getIndicatorStyle: function (item) {
      const index = item.indicator
      if (index === 0) {
        return 'color: green;'
      } else if (index === 1) {
        return 'color: yellow;'
      } else if (index === 2) {
        return 'color: red;'
      }
      return ''
    },
    getHDStyle: function (item) {
      var style = ''
      var prz = (100 / item.diskUsageMax) * item.diskUsageCurrent

      if (prz < 80) {
        style = 'color: green'
      } else {
        style = 'color: orange'
      }
      if (prz > 95) {
        style = 'color: red'
      }
      return style
    },
    getCompanyStyle: function (item) {
      var style = ''
      if (!item.company) {
        style = 'color: #aa4444;'
      }
      return style
    },
    toMB: function (bytes, decimals) {
      if (bytes == 0) return '0 Bytes';
      var k = 1024,
          dm = decimals <= 0 ? 0 : decimals || 2,
          sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'],
          i = Math.floor(Math.log(bytes) / Math.log(k));
      return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
    },
    getTags: function (item) {
      var t = JSON.parse(item.tags)
      return t
    },
    onGetCompanies: function (companies) {
      this.companies = companies
      if (this.companies.length>0) {
        this.filterNetwork = this.companies[0]
      }
      this.reloadSupportList()
    },
    doClear: function () {
      this.filterNetwork = null
      // this.reloadSupportList()
    },
    reloadSupportList: function () {
      var reqData = this.pagination
      if (!reqData) {
        reqData = {}
      }
      if (this.filterNetwork) {
        reqData.companyGuid = this.filterNetwork.guid
        // ok = ok && ((this.filterNetwork.guid === o.guidCompanyParent) || (this.filterNetwork.guid === o.guidCompany))
      } else {
        reqData.companyGuid = null
      }
      if (this.search) {
        reqData.keyWord = this.search.toLowerCase()
      }
      Vue.prototype.$api.showIdle()
      Vue.prototype.$api.loadDevicesWithMeta(reqData, this.onGetData)
    },
    reload: function () {
      var reqData = {
        isMother: 1
      }
      Vue.prototype.$apiCompany.loadCompanies(reqData, this.onGetCompanies)
    },
    updateStats: function () {
      this.stats = {
        cnt: 0,
        cntOffline: 0,
        cntOnline: 0
      }
      const cmp = this
      _.each(this.deviceList, function(item) {
        cmp.stats.cnt += 1
        if (item.indicator === 2) {
          cmp.stats.cntOffline += 1
        } else {
          cmp.stats.cntOnline += 1
        }
      })
    },
    doFilter: function (o) {
      let ok = true
      if (this.filterStati) {
        if ( this.filterStati === 'SERVICE') {
          ok = ok && (o.isService === 1)
        } else {
          ok = ok && ((this.filterStati === o.deviceState) && (o.isService !== 1))
        }

      }
      if (this.filterTown) {
        ok = ok && (this.filterTown === o.companyTown)
      }
      //if (this.filterNetwork) {
        // ok = ok && ((this.filterNetwork.guid === o.guidCompanyParent) || (this.filterNetwork.guid === o.guidCompany))
      //}
      /*
      if (this.search && this.search.length > 3) {
        const f = this.search.toLowerCase()
        ok = ok && JSON.stringify(o).toLowerCase().indexOf(f) > -1
      }*/
      if (this.tagArray && this.tagArray.length > 3) {
        const f = this.search.toLowerCase()
        ok = ok && JSON.stringify(o).toLowerCase().indexOf(f) > -1
      }
      if (!this.showAll) {
        if (o.indicator === 0) {
          ok = ok && false
        }
      }
      return ok
    },
    reFilter: async function () {
      const cmp = this
      Vue.prototype.storage.saveState('supportShowAll', this.showAll)
      Vue.prototype.storage.saveState('supportNetwork', this.filterNetwork)
      Vue.prototype.storage.saveState('supportStatus', this.filterStati)
      this.deviceList = _.filter(this.completeData, cmp.doFilter);
      this.updateStats()
    },
    resize: function () {
      this.tableHeight = window.innerHeight - 546;
      if (this.showTitle) {
        this.tableHeight = window.innerHeight - 420;
      }
      if (this.tableHeight < 150) {
        this.tableHeight = 150;
      }
    },
    onGetData: function (result) {
      this.towns = []
      let tHelper = {}
      var res = []
      for (var i in result) {
        var item = result[i]
        if (!item.companyName) {
          res.push(item)
        }
        if (item.companyTown) {
          if (!tHelper[item.companyTown]) {
            this.towns.push(item.companyTown)
            tHelper[item.companyTown] = true
          }
        }
      }
      this.networks = []
      this.deviceList = res
      this.towns = this.towns.sort()

      this.completeData = _.clone(result)
      let map = []
      let indexItem = 0
      for (var ii in result) {
        let item = result[ii]
        item.id = indexItem
        var t = JSON.parse(item.tags)
        item.tagArray = t
        for (var index in t) {
          let tag = t[index]
          map[tag] = tag
        }
        if (this.networks.indexOf(item.companyName) <= -1) {
          this.networks.push(item.companyName)
        }

        item.indicatorSort = this.getIndicatorIndex(item) + "_" + item.companyName
        item.indicator = this.getIndicatorIndex(item)
        indexItem++
      }
      this.tags = Object.keys(map)
      this.reFilter()
    }
  },
  mounted() {
    this.filterTown = null
    this.showAll = Vue.prototype.storage.getState('supportShowAll')
    this.filterNetwork = Vue.prototype.storage.getState('supportNetwork')
    this.filterStati = Vue.prototype.storage.getState('supportStatus')

    if (this.showAll) {
      this.headers = [
        {text: 'Status', value: 'indicatorSort'},
        {text: 'Name', align: 'left', value: 'name'},
        /* {text: 'Android Id', align: 'left', value: 'androidId'}, */
        {text: 'Standort', value: 'company'},
        {text: 'Stadt', align: 'left', value: 'companyTown'},
        /*{text: 'Screen', value: 'screenNumber'},*/
        {text: 'Client Version', value: 'clientVersionString'},
        /*{text: 'Tags', value: 'tags'},*/
        /*{text: 'HD Kapazität', value: 'diskUsageCurrent'},*/
        /*{text: 'Erstellt', value: 'created'},*/
        {text: 'Letzte Rückmeldung', value: 'lastHeartbeat', width: 240},
        /*{text: 'Remote', value: 'remoteAddress'},*/
        {text: 'Standort', value: 'company'},
        {text: 'Kommentar', value: 'comment'},
        {text: 'Aktion', value: 'action'}
      ]
    }

    var cmp = this
    this.$nextTick(() => {
      cmp.reload()
    })
    this.resize()
  },
  created() {
    Vue.prototype.$eventHub.$on('resize', this.resize)

  },
  destroyed() {
    Vue.prototype.$eventHub.$off('resize', this.resize)
  },
}
</script>

<style scoped>

</style>
